<template>
    <div class="forgetPwd">
        <div class="wrap">
            <div class="title_wrap">
                <span class="title_name">忘记密码</span>
            </div>
            <div class="email">
                <input type="text" placeholder="用户名" v-model="username" @blur="checkUsername">
            </div>
            <div class="email">
                <input type="text" placeholder="邮箱（注册时填写）" v-model="email" @blur="checkEmail">
            </div>
            <div class="code">
                <input type="text" placeholder="验证码" v-model="verification_code">
                <input type="button" value="发送验证码至邮箱"  @click="sendEmail">
            </div>
            <div class="next">
                <input type="button" value="确定" @click="update">
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import { Loading } from 'element-ui'

export default {
    data () {
        return {
            username: '',
            email: '',
            code: '',
            verification_code:''
        }
    },
    components: {
    },
    methods: {
        checkUsername: function () {
            let _t = this
            if(_t.username === ''){
                return _t.$messagewarning("用户名不能为空")
            }
        },
        checkEmail: function () {
            let _t = this
            const mailReg = /^([.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
            if(_t.email === ''){
                return _t.$messagewarning("邮箱不能为空")
            }
            if (!mailReg.test(_t.email)) {
                return _t.$messagewarning("请输入正确的邮箱格式")
            }
        },
        sendEmail: function () {
            let _t = this
            
            if(_t.email === ''){
                return _t.$messagewarning("邮箱不能为空")
            }
            _t.code = '' // 以防多次点击导致随机码过长
            // 生成随机码
            var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
            var len = 6
            var maxPos = chars.length
            for (var i = 0; i < len; i++) {
                let randomNum = Math.floor(Math.random() * maxPos)
                var char = chars.charAt(randomNum)
                _t.code += char
            }
            let ld = Loading.service({'fullscreen': true, 'text': '邮件发送中，请稍后'})
            axios.post(_t.API + '/api/regist/sendMail/', {'email': _t.email, 'code': _t.code})
            .then(function (resp) {
                if (resp.data.code === '409') {
                    _t.$messagewarning(resp.data.msg)
                    ld.close()
                    return
                }

                if (resp.data.code === '0') {
                    _t.$messagesuccess(resp.data.msg)
                } else {
                    _t.$messageerror(resp.data.msg)
                }

                ld.close()
            })
            .catch(function (error) {
                console.log(error)
                ld.close()
            })
        },
        update: function () {
            let _t = this
            if(_t.username === ''){
                return _t.$messagewarning("用户名不能为空")
            }
            if(_t.email === ''){
                return _t.$messagewarning("邮箱不能为空")
            }
            if(_t.verification_code === ''){
                return _t.$messagewarning("请输入验证码")
            }
            if(_t.code === _t.verification_code){
                _t.$router.push({name:'ChangePwd', params:{username: _t.username, email:_t.email}})
            }else{
                _t.$messagewarning("请输入正确的验证码")
            }
        }
    }
}
</script>
<style scoped lang='stylus'>
@import '~@/common/stylus/index'

.wrap{
    width: 600px;
    margin: 56px auto 300px;
}
.title_wrap{
    border-bottom: 1px solid #a3a3a3;
    margin-bottom: 25px;
    text-align: left;
    position: relative;
}
.title_name{
    font-family: sy;
    border-bottom: 4px solid $color-dark-blue;
    color: black;
    font-weight:600;
    font-size: 20px;
}
.email>input{
    height: 40px;
    font-size: 17px;
    width: 100%;
    padding-left: 10px;
    margin-bottom: 20px;
    border-radius: 2px;
    border: 1px solid $color-dark-blue;
}
.code>input:nth-child(1){
    height: 40px;
    font-size: 17px;
    width: 65%;
    padding-left: 10px;
    margin-right:40px;
    border-radius: 2px;
    border: 1px solid $color-dark-blue;
}
.code>input:nth-child(2){
    height: 40px;
    font-size: 15px;
    width: 25%;
    border:1px solid gray;
    border-radius: 4px;
    background:none;
    line-height: 38px;
    cursor: pointer;
}
.code>input:nth-child(2):hover{
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}
.code{
    margin-bottom:20px;
}
.next>input{
    border-radius: 4px;
    background: $color-dark-blue;
    height: 40px;
    line-height: 40px;
    color: #fff;
    width: 300px;
    cursor: pointer;
    font-size: 17px;
}
.next{
    text-align: center;
    margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// ForgetPwd.vue?4f2d4f2a